import {
  DropdownMenu,
  DropdownMenuContent,
} from '@src/design-system/dropdown-menu';
import { useGetMe } from '@src/shared/services/get-me';
import { useGetMemberships } from '@src/shared/services/get-memberships';
import { useParams } from 'react-router-dom';
import { ProfileMenuActions } from './profile-menu-actions';
import { ProfileMenuOrganizationList } from './profile-menu-organization-list';
import { ProfileMenuTrigger } from './profile-menu-trigger';

export function ProfileMenu() {
  const { data: memberships } = useGetMemberships();
  const { data: member } = useGetMe();

  const { organizationSlug } = useParams();

  const membership = memberships?.find(
    (membership) => membership.organization.slug === organizationSlug
  );

  const currentOrgName = membership?.organization?.name || '';
  const currentOrgCountry = membership?.organization?.country?.code || '';

  return (
    <div>
      <DropdownMenu modal={false}>
        <ProfileMenuTrigger
          member={member}
          currentOrgName={currentOrgName}
          currentOrgCountry={currentOrgCountry}
        />

        <DropdownMenuContent
          align='end'
          className='max-w-[300px] overflow-y-auto space-y-1'
        >
          <ProfileMenuOrganizationList memberships={memberships} />

          <ProfileMenuActions />
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
